import AttributesListTable from './attributesListTable.container';

export default AttributesListTable